/**
 * Commands module: creates the generic Command Bus. Owning modules register
 * their own command definitions against it during their init (review F-1).
 */
import { CoreModule } from "../core/CoreModule";
import { defineModule } from "../core/module";
import { CommandBus } from "./CommandBus";

export const CommandsModule = defineModule({
  name: "Commands",
  dependsOn: [CoreModule],
  init: ({ deps: { Core } }) => {
    const bus = new CommandBus({ scheduler: Core.scheduler, log: Core.log });
    Core.log.display("Commands", "command bus online · undo stack ready");
    return { bus };
  },
});
